import React from 'react';
import '../../style/chart_container.scss';
import '../../style/chart.scss';
import { createRandomKey } from '../../../../utils/jsxUtils';
import { getPercentPieChartConfig } from '../../getPieChartConfig';
import { ChartPercentLegend } from '../../legend/ChartLegend';
import { LazyReactChart } from '../../LazyReactChart';

type Props = {
  typologiesData: Array<number> | null;
  typologiesLabels: Array<string> | null;
};

export class CustomersTypologiesChart extends React.Component<Props> {
  typologiesCanvasId: string = `typologies-chart${createRandomKey()}`;

  typologiesBaseH = 158;

  render() {
    const { typologiesData, typologiesLabels } = this.props;
    return (
      <div className="chart-container">
        <div className="chart">
          {typologiesData && typologiesLabels && (
            <LazyReactChart
              config={getPercentPieChartConfig({
                data: typologiesData,
                labels: typologiesLabels,
                canvasId: this.typologiesCanvasId,
                baseH: this.typologiesBaseH,
              })}
            />
          )}
        </div>
        {typologiesData && typologiesLabels && (
          <ChartPercentLegend
            data={typologiesData}
            labels={typologiesLabels}
            baseH={this.typologiesBaseH}
          />
        )}
      </div>
    );
  }
}
